import { put } from '..';
import { TicketStatus } from '../../constants/Types';

type UpdatedStatus = TicketStatus.INPROGRESS | TicketStatus.COMPLETED;

const updateTicketStatus = (
  ticketId: string,
  status: UpdatedStatus,
  note?: string,
) => {
  const body: { status: UpdatedStatus, note?: string } = { status };
  if (note) body.note = note;

  return put(`assets/tickets/${ticketId}/status`, body);
};

export default updateTicketStatus;
